import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import useApiHttp from "../hooks/use-http";
import { Box } from "@mui/material";
import PageLoader from "../components/UI/Loader/PageLoader";

export default function QrCodeRegister() {
  const eventId = new URLSearchParams(useLocation().search).get("event_id");

  // const iosDeepLink = "https://apps.apple.com/us/app/jiosnap/id6479690823";
  // const androidDeepLink = `https://play.google.com/store/apps/details?id=com.jio.snap&event_id=${eventId}`;
  // const androidDeepLink = `https://play.google.com/store/apps/details?id=com.jio.photos&event_id=${eventId}`;

  // const iosDeepLink = "https://apps.apple.com/in/app/jiophotos/id6450602471";
  // const androidDeepLink = `https://play.google.com/store/apps/details?id=com.jio.photos&referrer=${eventId}&event_id=${eventId}`;

  const [deepLinks, setDeepLinks] = useState();
  const [isError, setIsError] = useState(false);

  const { sendRequest: getDeepLinksApi, isLoading: isGettingDeeplink } =
    useApiHttp();
  const getDeepLinksHandler = () => {
    getDeepLinksApi(
      {
        url: `event/read-deep-links/${eventId}`,
      },
      null,
      (data) => {
        setDeepLinks(data?.data);
      },
      (_, err) => {
        setIsError(true);
      }
    );
  };

  useEffect(() => {
    getDeepLinksHandler();
  }, []);

  useEffect(() => {
    // NEW
    if (deepLinks) {
      const os = getOS();
      if (os == "iOS") {
        window.location.href = deepLinks?.iosDeepLink;
      } else if (os == "Android Phone") {
        window.location.href = deepLinks?.androidDeepLink;
      } else {
        //   setShowCard(true);
        //   getData();
      }
    }
  }, [deepLinks]);

  const getOS = () => {
    const userAgent = navigator.userAgent || window.opera;

    // iOS detection
    if (/iPhone/.test(userAgent)) {
      return "iOS";
    }

    // macOS detection
    if (/Macintosh/.test(userAgent) && !("ontouchend" in document)) {
      return "macOS";
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      // Further check if it's a tablet
      const isTablet = /tablet|ipad/i.test(userAgent);
      return isTablet ? "Android Tablet" : "Android Phone";
    }

    // Default to unknown if none matches
    return "unknown";
  };
  return <Box>{isGettingDeeplink && <PageLoader />}</Box>;
}
